//Film
export const FETCH_FILM = "FETCH_FILM";
export const FETCH_FILM_FOLLOW_DAY = "FETCH_FILM_FOLLOW_DAY";
export const FETCH_FILM_FOLLOW_PAGE = "FETCH_FILM_FOLLOW_PAGE";
export const FETCH_BANNER_FILM = "FETCH_BANNER_FILM";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const FETCH_FILM_DETAIL = "FETCH_FILM_DETAIL";
export const FETCH_FILM_SHOWTIME = "FETCH_FILM_SHOWTIME";

//User
export const SIGN_IN = "SIGN_IN";
export const SIGN_UP = "SIGN_UP";
export const USER__INFO_BOOKING = "USER__INFO_BOOKING";
export const CHANGE__INFO = "CHANGE__INFO";
// export const FETCH_AVATAR = "FETCH_AVATAR";
// export const CREATE_AVATAR = "CREATE_AVATAR";
// export const UPDATE_AVATAR = "UPDATE_AVATAR";
// export const DELETE_AVATAR = "DELETE_AVATAR";

//Cinema
export const FETCH_CINEMA_SYSTEM = "FETCH_CINEMA_SYSTEM";
export const FETCH_CINEMA_INFO_IN_SYSTEM = "FETCH_CINEMA_INFO_IN_SYSTEM";
export const FETCH_FILM_FOLLOW_CINEMA = "FETCH_FILM_FOLLOW_CINEMA";
export const SELECTED_ID_CINEMA = "SELECTED_ID_CINEMA";
export const SELECTED_DATE = "SELECTED_DATE";
export const FETCH_TICKET_ROOM = "FETCH_TICKET_ROOM";
export const FETCH_TICKET_ROOM_CHAIR = "FETCH_TICKET_ROOM_CHAIR";
export const SELECT_CHAIR = "SELECT_CHAIR";
export const BOKING_TICKETS = "BOKING_TICKETS";

//News
export const FETCH_NEWS = "FETCH_NEWS";
export const FETCH_NEWS_DETAIL = "FETCH_NEWS_DETAIL";

//FOOD
export const FETCH_FOOD = "FETCH_FOOD";
export const ADD_FOOD = "ADD_FOOD";
export const OPTIONAL_QUANTITY = "OPTIONAL_QUANTITY";
export const DELETE_FOOD = "DELETE_FOOD";
export const AMOUNT_MONEY = "AMOUNT_MONEY";

//ADMIN
export const FETCH_USER = "FETCH_USER";
export const SEARCH_USER = "SEARCH_USER";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_NOTIFY = "UPDATE_NOTIFY";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_MOVIE = "DELETE_MOVIE";
export const SEARCH_FILM = "SEARCH_FILM";
export const ADD_FILM = "ADD_FILM";
export const UPDATE_FILM = "UPDATE_FILM";
export const CREATE_SHOWTIME = "CREATE_SHOWTIME";

// comment

export const FETCH_COMMENT = "FETCH_COMMENT";
export const ADD_COMMENT = "ADD_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
